import React from 'react';
import { motion } from 'framer-motion';
import { LeadForm } from './LeadForm';
export function FinalCTA() {
  return <section className="py-10 lg:py-20 bg-brand-darkAlt relative overflow-hidden" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-78">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-79">
            <h2 className="text-3xl md:text-5xl font-light text-white mb-6 leading-tight" data-id="element-80">
              Your Confident Smile Is Closer Than You Think
            </h2>
            <p className="text-xl text-white/60 mb-8" data-id="element-81">
              Claim your free consultation + $3,000 off before this limited-time
              offer ends.
            </p>

            <div className="hidden lg:flex flex-col gap-4 text-white/50" data-id="element-82">
              <div className="flex items-center gap-3" data-id="element-83">
                <div className="w-1.5 h-1.5 bg-brand-cream rounded-full" data-id="element-84"></div>
                <p data-id="element-85">No commitment required</p>
              </div>
              <div className="flex items-center gap-3" data-id="element-86">
                <div className="w-1.5 h-1.5 bg-brand-cream rounded-full" data-id="element-87"></div>
                <p data-id="element-88">We'll call you within 5 minutes</p>
              </div>
              <div className="flex items-center gap-3" data-id="element-89">
                <div className="w-1.5 h-1.5 bg-brand-cream rounded-full" data-id="element-90"></div>
                <p data-id="element-91">Trusted by Miami Lakes families</p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative z-10" data-id="element-92">
            <LeadForm data-id="element-93" />

            <p className="text-center text-white/40 text-sm mt-6 lg:hidden" data-id="element-94">
              No commitment required. We'll call you within 5 minutes.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}